import { Tooltip, Box } from '@mui/material';
import React, { useRef, useState } from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle'; // ✅ MUI green tick icon
import CSVIcon from "../../../src/assests/images/csvUpload.jpg";

export default function CSVUpload() {
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [uploadSuccess, setUploadSuccess] = useState(false); // ✅ state to track upload

    const handleClick = () => {
        if (!uploadSuccess) {
            fileInputRef.current?.click();
        }
    };

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            console.log("CSV uploaded:", file.name);
            setUploadSuccess(true); // ✅ set success
        }
    };

    return (
        <>
            <Tooltip
                title="Upload CSV For Location"
                arrow
                placement="top"
                componentsProps={{
                    tooltip: {
                        sx: {
                            backgroundColor: '#1c1c1c',
                            fontSize: '14px',
                            borderRadius: '6px',
                            padding: '6px 12px',
                        },
                    },
                    arrow: {
                        sx: {
                            color: '#1c1c1c',
                        },
                    },
                }}
            >
                <Box
                    onClick={handleClick}
                    sx={{
                        width: 48,
                        height: 48,
                        border: uploadSuccess ? '2px solid #22683E' : '2px solid #d32f2f',
                        borderRadius: '12px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: uploadSuccess ? 'not-allowed' : 'pointer',
                        position: 'relative',
                        backgroundColor: uploadSuccess ? '#fff' : '#fff',
                        '&:hover': {
                            backgroundColor: uploadSuccess ? '#fff' : '#fff',
                        },
                    }}
                >
                    {uploadSuccess ? (
                        <CheckCircleIcon
                            sx={{
                                color: '#22683E',
                                fontSize: 18,
                                position: 'absolute',
                                top: 9,
                                right: 9,
                                backgroundColor: 'white',
                                borderRadius: '50%',
                                width: "26px",
                                height: "26px"
                            }}
                        />
                    ) : (
                        <img
                            src={CSVIcon}
                            alt="Upload"
                            style={{ width: 24, height: 24 }}
                        />
                    )}
                </Box>
            </Tooltip>

            <input
                type="file"
                accept=".csv"
                ref={fileInputRef}
                onChange={handleFileChange}
                style={{ display: 'none' }}
            />
        </>
    );
}
